import React, { useContext } from 'react';
const FormTextContext = React.createContext({});
const useFormTextContext = ({ suppressWarning, customError, }) => {
    const context = useContext(FormTextContext);
    // if any values are `undefined` we know that the hook is being used outside
    // of a FormTextProvider
    if ((context === null || context === void 0 ? void 0 : context.isFocused) === undefined && suppressWarning !== true) {
        throw new Error(customError ||
            'useFormTextContext must be consumed inside of a FormTextProvider');
    }
    return context;
};
const FormTextProvider = ({ className, children, hasError, isDisabled, isFocused, isHovered, setFocused, setHovered, characterCounterWidth = 8, }) => {
    return (React.createElement(FormTextContext.Provider, { value: {
            isFocused,
            isHovered,
            hasError,
            isDisabled,
            characterCounterWidth,
            setFocused,
            setHovered,
        } }, children));
};
export { FormTextProvider, FormTextContext, useFormTextContext, };
//# sourceMappingURL=FormTextContext.js.map